<template>
  <router-view v-slot="{ Component }">
    <keep-alive>
      <component :is="Component" v-if="$route.meta.keepAlive" />
    </keep-alive>
    <component :is="Component" v-if="!$route.meta.keepAlive" />
  </router-view>
</template>

<style lang="scss">
html,
body {
  padding: 0;
  margin: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  // ie
  scrollbar-arrow-color: #a8a8a8;
  /*三角箭头的颜色*/
  scrollbar-face-color: #a8a8a8;
  /*立体滚动条的颜色（包括箭头部分的背景色）*/
  scrollbar-3dlight-color: #eeeeee;
  /*立体滚动条亮边的颜色*/
  scrollbar-highlight-color: #a8a8a8;
  /*滚动条的高亮颜色（左阴影？）*/
  scrollbar-shadow-color: #a8a8a8;
  /*立体滚动条阴影的颜色*/
  scrollbar-darkshadow-color: #a8a8a8;
  /*立体滚动条外阴影的颜色*/
  scrollbar-track-color: #eeeeee;
  /*立体滚动条背景颜色*/
  scrollbar-base-color: #bebebe;
  /*滚动条的基色*/
  // Firefox
  scrollbar-color: #eeeeee;
  scrollbar-width: thin;
}

::-webkit-scrollbar-track-piece {
  //滚动条凹槽的颜色，还可以设置边框属性
  border-radius: 4px;
  background-color: #0624525b;
}
::-webkit-scrollbar {
  //滚动条的宽度
  width: 6px;
  height: 6px;
}
::-webkit-scrollbar-thumb {
  //滚动条的设置
  border-radius: 4px;
  background-color: #a5a5a586;
  background-clip: padding-box;
  min-height: 28px;
}
::-webkit-scrollbar-thumb:hover {
  background-color: #b9b9b991;
}

#app {
  width: 100%;
  height: 100%;
  overflow: hidden;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
